// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import { urlTimeSheetService } from '@src/endpoints'

import { getUriParams } from '@src/utility/Utils'
import toast from 'react-hot-toast'

export const getAllData = createAsyncThunk('outsourcedTSReport/getAllData', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllTimeSheetsCount?isTempWorker=true`)
  return {
    data: response.data,
    loadedAll: true
  }
})

export const getData = createAsyncThunk('outsourcedTSReport/getData', async params => {
  const uri = getUriParams(params)

  let startDate = new Date()
  let endDate = new Date()
  const currentDay = new Date().getDate()

  const monthMidStart = startDate.getMonth() === 0 ? `${startDate.getFullYear() - 1}-12-16` : `${startDate.getFullYear()}-${endDate.getMonth()}-16`
  const monthEnd = endDate.getMonth() === 0 ? `${endDate.getFullYear() - 1}-12-${new Date(endDate.getFullYear() - 1, 12, 0).getDate()}` : `${endDate.getFullYear()}-${endDate.getMonth()}-${new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate()}`

  startDate = startDate.getDate() > 15 ? `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate() - currentDay + 1}` : monthMidStart
  endDate = endDate.getDate() > 15 ? `${endDate.getFullYear()}-${endDate.getMonth() + 1}-15` : monthEnd

  // Convert Date objects to ISO string format if they are Date instances
  let formattedStartDateTime = params.startDateTime
  let formattedEndDateTime = params.endDateTime

  if (params.startDateTime instanceof Date) {
    formattedStartDateTime = params.startDateTime.toISOString()
  }

  if (params.endDateTime instanceof Date) {
    formattedEndDateTime = params.endDateTime.toISOString()
  }

  const TimeSheetFilter = {
    userId: params.userId,
    punchType: params.punchType !== null ? params.punchType : null,
    startDateTime: formattedStartDateTime === null ? startDate : formattedStartDateTime,
    endDateTime: formattedEndDateTime === null ? endDate : formattedEndDateTime,
    siteLocation: params.siteLocation,
    status: params.status,
    isTempWorker: true,
    companyId: params.companyId ?? null,
    isDriver: false
  }

  const response = await axios.post(`${urlTimeSheetService}/GetTimeSheetsUserHours?${uri}`, TimeSheetFilter)

  return {
    params,
    data: response.data,
    totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
    loaded: true
  }
})

export const getAllEmployeesSelect = createAsyncThunk('outsourcedTSReport/getAllEmployeesSelect', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllEmployeesSelect?isTempWorker=true`)
  const allEmployees = [{ value: null, label: 'Select...' }, ...response.data.data]
  return allEmployees
})

export const addNewTimeSheet = createAsyncThunk('outsourcedTSReport/addNewTimeSheet', async (TimeSheetViewModel) => {
  const response = await axios.post(`${urlTimeSheetService}/AddNewTimeSheet`, TimeSheetViewModel)
  if (response.data.success) {
    toast.success(response?.data?.messages)
  } else {
    toast.error(response?.data?.errors)
  }
})

export const updateTimeSheet = createAsyncThunk('outsourcedTSReport/updateTimeSheet', async (TimeSheetViewModel) => {
  const response = await axios.post(`${urlTimeSheetService}/UpdateTimeSheet`, TimeSheetViewModel)
  if (response.data.success) {
    toast.success(response?.data?.messages)
  } else {
    toast.error(response?.data?.errors)
  }
})

export const outsourcedTSReportSlice = createSlice({
  name: 'outsourcedTSReport',
  initialState: {
    loaded: false,
    loadedAll: false,
    data: [],
    total: 1,
    params: {},
    allData: {},
    allEmployees: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.pending, (state) => {
        state.loadedAll = false
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.loadedAll = action.payload.loadedAll
        state.allData = action.payload.data
      })
      .addCase(getData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getAllEmployeesSelect.fulfilled, (state, action) => {
        state.allEmployees = action.payload
      })
  }
})

export default outsourcedTSReportSlice.reducer
